module.exports = __webpack_public_path__ + "static/bsas005.thumb-817da2d2baa3c26780d0a0df7b8bdf24.jpg";